/**
 * AI Job 종류 상수 정의
 * 서버의 BatchJobKinds enum과 일치하도록 정의
 */

export const AI_JOB_KINDS = Object.freeze({
  // RGB 이미지 작업
  RGB_LOC: 'RGB_LOC',
  
  // 열화상 이미지 작업
  IR_LOC: 'IR_LOC',      // 위치정보 추출
  IR_DATA: 'IR_DATA',    // 온도데이터 추출
  IR_DEFECT: 'IR_DEFECT' // AI 결함 검출
});

/**
 * Job 종류별 분류
 */
export const JOB_CATEGORIES = Object.freeze({
  RGB: [AI_JOB_KINDS.RGB_LOC],
  THERMAL: [AI_JOB_KINDS.IR_LOC, AI_JOB_KINDS.IR_DATA, AI_JOB_KINDS.IR_DEFECT]
});

/**
 * Job 종류가 RGB인지 확인
 */
export const isRgbJob = (jobKind) => {
  return JOB_CATEGORIES.RGB.includes(jobKind);
};

/**
 * Job 종류가 Thermal인지 확인
 */
export const isThermalJob = (jobKind) => {
  return JOB_CATEGORIES.THERMAL.includes(jobKind);
};

/**
 * AI Job 종류별 라벨 (i18n 미적용·알 수 없는 코드 시 폴백)
 * UI 표시는 utils/aiJobUtils의 formatJobKinds / getJobKindLabel (aiJobKind.*) 사용
 */
export const AI_JOB_KIND_LABELS = Object.freeze({
  [AI_JOB_KINDS.RGB_LOC]: 'RGB 이미지 Geo-Localization',
  [AI_JOB_KINDS.IR_LOC]: '열화상 이미지 Geo-Localization',
  [AI_JOB_KINDS.IR_DATA]: '온도데이터 추출',
  [AI_JOB_KINDS.IR_DEFECT]: 'AI 결함 검출'
});

